<template lang='pug'>
transition(name='fade')
    .modal-backdrop(@click='close')
        .modal-dialog(@click.stop='', :style='{ width }')
            .modal-header(:style='[title ? "" : { justifyContent: "flex-end" } ]')
                .modal-title(v-if='title')
                    span(v-html='title')
                .modal-close(@click='close')
                    .mdi.mdi-close
            slot
</template>

<script>
export default {
    name: 'ModalComponent',

    props: {
        title: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            default: 'fit-content',
        },
    },

    methods: {
        close() {
            this.$emit('close');
            this.$destroy();
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter .modal-dialog,
.fade-leave-to .modal-dialog {
    transform: translateY(-20%);
}

.modal-backdrop {
    background: rgba(250, 250, 250, 0.8);
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.modal-dialog {
    background: rgb(255, 255, 255);
    padding: 10px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    transition: 0.5s;
    position: relative;
}

.modal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid var(--primary-dark-smoke);
    padding-bottom: 10px;
}

.modal-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    border-top: 1px solid var(--primary-dark-smoke);
    padding-top: 10px;
}

.modal-close {
    fill: rgb(150, 150, 150);
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.modal-close:hover {
    fill: rgb(100, 100, 100);
    background-color: rgba(225, 218, 218, 0.475);
    cursor: pointer;
}

.modal-title {
    padding: 3px;
    text-align: left;
    font-size: 18px;
    color: var(--primary-green);
}

.modal-body {
    padding: 15px;
}
</style>
